import { render } from "./EventsView.vue?vue&type=template&id=7e688789&scoped=true"
import script from "./EventsView.vue?vue&type=script&lang=js"
export * from "./EventsView.vue?vue&type=script&lang=js"

import "./EventsView.vue?vue&type=style&index=0&id=7e688789&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e688789"]])

export default __exports__